export class DistanceServices {
  static EARTH_RADIUS_MILES = 3958.8;

  static degreesToRadians(degrees) {
    return (degrees * Math.PI) / 180;
  }

  static distanceInBetweenGPSCoordinates(position1, position2) {
    const dLat = DistanceServices.degreesToRadians(position2.latitude - position1.latitude);
    const dLon = DistanceServices.degreesToRadians(position2.longitude - position1.longitude);

    const a = (Math.sin(dLat / 2) * Math.sin(dLat / 2)) + (Math.sin(dLon / 2) * Math.sin(dLon / 2) *
      Math.cos(DistanceServices.degreesToRadians(position1.latitude)) * Math.cos(DistanceServices.degreesToRadians(position2.latitude)));
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return DistanceServices.EARTH_RADIUS_MILES * c;
  }

  static inBoundingBox(topRightLat, topRightLng, bottomLeftLat, bottomLeftLng, pointLat, pointLong) {
    let isLongInRange;
    if (topRightLng < bottomLeftLng) {
      isLongInRange = (pointLong >= bottomLeftLng) || (pointLong <= topRightLng);
    } else {
      isLongInRange = (pointLong >= bottomLeftLng) && (pointLong <= topRightLng);
    }
    return (pointLat >= bottomLeftLat) && (pointLat <= topRightLat) && isLongInRange;
  }
}
